<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="角色名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>

            <el-form-item label="角色标识" prop="flag" :error="formErrorMsg.flag"  class="fb-form-item">
                <el-input v-model="formData.flag" ></el-input>
            </el-form-item>

            <el-form-item label="角色描述" prop="description"  class="fb-form-item" >
                <el-input v-model="formData.description"></el-input>
            </el-form-item>


            <el-form-item label="角色状态" prop="status"  class="fb-form-item" >
                <el-select v-model="formData.status" placeholder="请选择用户状态">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="功能设置" prop="actionCodes">
                <action-choose-box v-model="formData.actionCodes"></action-choose-box>
            </el-form-item>


            <el-form-item label="角色菜单" prop="menuItemCodes">

                <menu-choose-box v-model="formData.menuItemCodes"></menu-choose-box>

            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import ActionChooseBox from "../../components/action-choose-box/ActionChooseBox";
    import MenuChooseBox from "../../components/menu-choose-box/MenuChooseBox";
    export default {
        name: "RoleAdd",
        components: {MenuChooseBox, ActionChooseBox},
        data() {
            return {
                api:{
                   add:this.$api.role.add
                },
                formErrorMsg:{name: '',
                    flag: ''},
                formData: {
                    name: '',
                    flag: '',
                    description: '',
                    actionCodes:[],
                    menuItemCodes:[],
                    status: '1',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入角色名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入角色标识', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.add,this.formData).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>